export default "__VITE_ASSET__QrfgsrDK__"